import React, { useState } from 'react';

function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navLinks = [
    { name: 'Services', href: '#services' },
    { name: 'Gallery', href: '#gallery' },
    { name: 'About', href: '#about' },
    { name: 'FAQ', href: '#faq' },
    { name: 'Contact', href: '#contact' },
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <nav className="bg-brand-800 text-white sticky top-0 z-50 shadow-lg">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-16 md:h-20">
          {/* Logo/Brand */}
          <a href="#" className="flex items-center space-x-2" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
            <img
              src="/logo-primary.jpg"
              alt="Anders Ponds & Lakes - Tampa Bay Pond and Lake Management Services"
              className="w-8 h-8 md:w-10 md:h-10 rounded-md object-cover"
            />
            <span className="text-lg md:text-xl font-bold hidden sm:inline">Anders Ponds & Lakes</span>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-6">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                onClick={(e) => scrollToSection(e, link.href)}
                className="text-brand-100 hover:text-white transition-colors font-medium"
              >
                {link.name}
              </a>
            ))}
            {/* Desktop CTAs */}
            <a
              href="tel:+17272773366"
              className="bg-water-600 hover:bg-water-700 text-white font-bold py-2 px-4 rounded-lg transition-colors"
            >
              (727) 277-3366
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-brand-700 transition-colors min-w-[44px] min-h-[44px] flex items-center justify-center"
            aria-label="Toggle menu"
          >
            {isMenuOpen ? (
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden pb-4 border-t border-brand-700">
            <div className="flex flex-col space-y-2 pt-4">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  onClick={(e) => scrollToSection(e, link.href)}
                  className="text-brand-100 hover:text-white hover:bg-brand-700 px-4 py-3 rounded-lg transition-colors font-medium min-h-[48px] flex items-center"
                >
                  {link.name}
                </a>
              ))}
              {/* Mobile CTAs */}
              <div className="border-t border-brand-700 pt-4 mt-2 space-y-3 px-4">
                <a
                  href="tel:+17272773366"
                  className="flex items-center justify-center bg-water-600 hover:bg-water-700 text-white font-bold py-4 px-6 rounded-lg transition-colors min-h-[56px]"
                >
                  <span className="mr-2">📞</span>
                  Call Joe: (727) 277-3366
                </a>
                <a
                  href="#contact"
                  onClick={(e) => scrollToSection(e, '#contact')}
                  className="flex items-center justify-center bg-nature-600 hover:bg-nature-700 text-white font-bold py-4 px-6 rounded-lg transition-colors min-h-[56px]"
                >
                  <span className="mr-2">✉️</span>
                  Email for Quote
                </a>
              </div>

              {/* Social Media - Mobile Only */}
              <div className="border-t border-brand-700 pt-4 mt-2 px-4">
                <p className="text-sm font-semibold text-brand-200 mb-3">Connect With Us</p>
                <a
                  href="https://www.facebook.com/p/Anders-Ponds-Lakes-61577351702894/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center text-brand-100 hover:text-white hover:bg-brand-700 px-4 py-3 rounded-lg transition-colors min-h-[48px]"
                  aria-label="Visit Anders Ponds on Facebook"
                >
                  <svg className="w-6 h-6 mr-3 text-[#1877F2]" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                  <span className="font-medium">Follow Us on Facebook</span>
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}

export default Navigation;
